import {APPLICATION_ROUTES_CONSTANTS} from '../app/core/constants/application-routes.constants';
import { ASSETS_CONSTANTS } from '../app/core/constants/assets.constants';

export const environment = {
  version: 'v3.0.1-beta',
  production: true,
  applicationName: 'ReviseIt',
  apiBaseUrl: 'https://api.reviseit.cloud/api',
  contactEmail: 'info@reviseit.cloud',
  socialMediaLinks: {
    instagram: 'https://www.instagram.com/reviseit.cloud/',
    tiktok: 'https://www.tiktok.com/@reviseit.cloud',
    linkedin: 'https://www.linkedin.com/company/reviseit-cloud/',
  },
  creatorLinks: {
    contactEmail: 'm.javadfalahati@gmail.com',
    linkedin: 'https://www.linkedin.com/in/javad-falahati-93b95a22a/',
    buyMeACoffee: 'https://www.buymeacoffee.com/javadfalahati',
  },
  sso: {
    google: {
      clientId: '530067293996-vkshj7nqelce50fursc9iknsqh06k12m.apps.googleusercontent.com'
    }
  },
  defaultLanguageCode: 'EN',
  defaultPaginationPageNumber: 1,
  defaultPaginationPageSize: 20,
  reviewSessionSettings: {
    maximumReviewSessions: 20
  },
  importSetting: {
    options: [
      {
        id: APPLICATION_ROUTES_CONSTANTS.ROUTES.IMPORT.KINDLE_HTML.IMPORT,
        allowedFileTypes: ['.html', '.htm'],
        title: 'Kindle',
        description: 'Import your Kindle books and documents',
        logo: ASSETS_CONSTANTS.IMAGES.KINDLE_LOGO,
        icon: 'fas fa-book',
        available: true,
        color: '#1179ec',
        gradient: ['#1179ec', '#2f8bf3'],
        route: APPLICATION_ROUTES_CONSTANTS.ROUTES.IMPORT.KINDLE_HTML.IMPORT
      },
      {
        id: APPLICATION_ROUTES_CONSTANTS.ROUTES.IMPORT.APPLE_BOOK.IMPORT,
        allowedFileTypes: ['.eml', '.html', '.htm'],
        title: 'Apple Books',
        description: 'Import your Apple Books highlights and notes',
        logo: ASSETS_CONSTANTS.IMAGES.APPLE_BOOK_LOGO,
        icon: 'fas fa-book',
        available: true,
        color: '#fc3158',
        gradient: ['#fc3158', '#ff7aa8'],
        route: APPLICATION_ROUTES_CONSTANTS.ROUTES.IMPORT.APPLE_BOOK.IMPORT
      },
      {
        id: APPLICATION_ROUTES_CONSTANTS.ROUTES.IMPORT.EXCEL.IMPORT,
        allowedFileTypes: ['.csv', '.xls', '.xlsx', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv'],
        title: 'Excel/CSV',
        description: 'Import data from Excel spreadsheets or CSV files',
        icon: 'fas fa-file-excel',
        logo: null,
        available: true,
        color: '#00a693',
        gradient: ['#00a693', '#85ede0'],
        route: APPLICATION_ROUTES_CONSTANTS.ROUTES.IMPORT.EXCEL.IMPORT
      },
      {
        id: 'pdf',
        allowedFileTypes: ['.pdf', 'application/pdf'],
        title: 'PDF',
        description: 'Import content from PDF documents and files',
        logo: null,
        icon: 'fas fa-file-pdf',
        available: false,
        color: '#ff6b6b',
        gradient: ['#ff6b6b', '#ff8e8e'],
        route: 'import/pdf'
      },
    ]
  }
};
